
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ControlsTreeExpansionPanels from "./ControlsTreeExpansionPanels.vue";
import ControlsTreeLinear from "./ControlsTreeLinear.vue";
import { Control } from "@/types/controls";

@Component({
  name: "ControlsTree",
  components: {
    ControlsTreeExpansionPanels,
    ControlsTreeLinear
  }
})
export default class ControlsTree extends Vue {
  @Prop()
  controls!: Control[];

  @Prop({ default: false })
  linear!: boolean;

  @Prop({ default: false })
  allowPopoutsInRoot!: boolean;

  @Prop({
    default: false
  })
  forceFirstSectionOpen!: boolean;

  @Prop()
  path!: string;
}
